// The org that owns the current session, as the recording queue understands it.
//
// Captured recordings are stamped with this (useIndexDb's addRecording /
// addRecordingSegment) so the finalless rebuild can fail CLOSED on an absent or
// foreign org — no cross-org upload (spec §14C) — and the Local Recordings modal
// asks the same question when deciding whether Retry can do anything for an
// unfinished row. ONE definition, so the two can never disagree about what
// "the current org" is. Guarded: a storage failure never throws into a write.
export function currentOrgId() {
  try {
    return localStorage.getItem("organization") || null;
  } catch {
    return null;
  }
}
